import { nextTick } from 'vue';
import { showSubmitLoader, hideSubmitLoader } from '@atoms/spinner';
import requests from '@tools/requests';

export default {
  /**
   * onClickEvent
   *
   * This methods attach on click event to the element
   * witch id is passed in params.
   * The callback passed in parameter is triggered when the element is clicked on.
   *
   * @param id       An Id of an element HTML
   * @param callback Callback to call whenever the element is clicked on
   *
   */
  onClickEvent(id, callback) {
    if (typeof callback !== 'function') {
      throw new Error('callback is not a function');
    }

    nextTick(() => {
      const element = document.getElementById(id);
      if (!element || element.nodeType !== 1) {
        throw new Error('element is not a valid HTML element');
      }

      element.addEventListener('click', callback);
    });
  },

  /**
   * Submit a twig form with async request
   *
   * @param event
   * @param url
   * @returns {Promise}
   */
  asyncSubmit(event, url) {
    const form = event.currentTarget;
    event.preventDefault();
    const formData = new FormData(form);
    showSubmitLoader(form.querySelector('button[type="submit"]'));
    const requestUrl = url || form.action;
    return new Promise((resolve, reject) => {
      requests.post(requestUrl, formData, {
        headers: {
          'Cache-Control': 'no-cache',
          Pragma: 'no-cache', // Prevent caching AJAX calls on IE
        },
      }).then((result) => {
        resolve(result);
      }).catch((error) => {
        hideSubmitLoader(form.querySelector('button[type="submit"]'));
        reject(error);
      });
    });
  },
};
